import { gql } from '@apollo/client';
// local imports
import { API_ADMIN_REPORT } from '../config/api';

export const ADMIN_MENTORED_SKILLS_BY_EMPLOYEE_QUERY = gql`
  query ARMentoredSkillsByEmployee(
    $report_id: Int!
    $offset: Int
    $limit: Int
  ) {
    arMentoredSkillsByEmployee(
      report_id: $report_id,
      offset: $offset,
      limit: $limit
    )
    @rest(
      type: "ARMentoredSkillsByEmployeePayload",
      path: "${API_ADMIN_REPORT}?limit={args.limit}&offset={args.offset}"
    ) {
      count
      results {
        id
        code
        email
        first_name
        last_name
        is_contractor
        count
      }
    }
  }
`;
